import $ from 'jquery'

class Lottie {
  constructor(element) {
    if (!element) {
      return false
    }

    this.elem = jQuery(element)
    this._iniLottie()
  }

  _iniLottie() {
    this.elem.each(function (i) {
      var $lottiePlayer = $(this).find('lottie-player')
      var lottiePlayerID = $lottiePlayer.attr('id')
  
      LottieInteractivity.create({
        player: '#' + lottiePlayerID,
        mode: 'cursor',
        container: $(this)[0],
        actions: [
          {
            type: 'hover',
            forceFlag: true, // Ensures the animation will play on hover
          },
        ],
      })
    })
  }
}
export default Lottie
